const Sidebar = () => (
  <aside className="bg-gray-200 md:flex md:flex-shrink-0">
    <div className="flex flex-col w-64">
      <nav className="flex-1 px-2 space-y-1">sidebar</nav>
    </div>
  </aside>
);

export default Sidebar;
